// extracted by mini-css-extract-plugin
export default {"container":"Tags_container__vNpID","content":"Tags_content__eD1mC"};